import MuiTable from "@mui/material/Table";

/**
 * Facade over MUI Table. Customize defaults here.
 */
export default function Table(props) {
  return <MuiTable {...props} />;
}
